export default {"src":"/_next/static/media/django.0d24a6f2.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};